import React, { PureComponent } from "react";

/**
 * 通过 iframe 创建小部件
 */
class WidgetForIframe extends PureComponent {
    constructor(props) {
        super(props);
    }
    createWidgetDom = () => {
        let { name, cardId, groupId, src, appcode, width, height } = this.props;
        const widget = document.createElement("iframe");
        const wh = `${width !== undefined && height !== undefined ? `&widgetWidth=${width}&widgetHeight=${height}` : ""}`; //部件宽高
        const iframeUrl = `${src}?appcode=${appcode}${wh}`; //小部件路径拼上appcode
        widget.setAttribute("fieldid", `${name}_app-item`);
        widget.setAttribute("cid", cardId);
        widget.style.width = "100%";
        widget.style.height = "100%";
        widget.frameBorder = "0";
        widget.scrolling = "no";
        document.getElementById(`${groupId}_${cardId}`).appendChild(widget);
        let widgetDoc = widget.contentWindow.document;
        widgetDoc
            .open()
            .write(`<body onload="window.location.href='${iframeUrl}';">`);
        widgetDoc.close();
    };
    componentDidMount() {
        let { cardId, groupId } = this.props;
        if (!document.getElementById(`${groupId}_${cardId}`).hasChildNodes())
        {this.createWidgetDom();}
    }
    componentDidUpdate() {
        let { cardId, groupId } = this.props;
        if (!document.getElementById(`${groupId}_${cardId}`).hasChildNodes())
        {this.createWidgetDom();}
    }
    render() {
        let { cardId, groupId } = this.props;
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                }}
                id={`${groupId}_${cardId}`}
                className="app-item"
            />
        );
    }
}
export default WidgetForIframe;
